import * as React from "react";

// @ts-ignore
import Script from "react-load-script";

const PLAID_LINK_URL =
  "https://cdn.plaid.com/link/v2/stable/link-initialize.js";
const API_VERSION = "v2";

export interface PlaidLinkMeta {
  institution?: {
    name: string;
    institution_id: string;
  };
}

export enum PlaidEnv {
  Tatran = "tatran",
  Sandbox = "sandbox",
  Development = "development",
  Production = "production"
}

export enum PlaidProduct {
  Connect = "connect",
  Info = "info",
  Auth = "auth",
  Identity = "identity",
  Income = "income",
  Transactions = "transactions",
  Assets = "assets",
  Liabilities = "liabilities"
}

interface IProps {
  clientName: string;
  env: PlaidEnv;
  institution?: string;
  publicKey: string;
  products: PlaidProduct[];
  token?: string;
  selectAccount?: boolean;
  webhook?: string;
  onSuccess: (token: string, metadata: PlaidLinkMeta) => void;
  onExit: () => void;
  onLoad?: () => void;
  onEvent?: (event: any) => void;
  className?: string;
}

interface IState {
  linkLoaded: boolean;
}

export default class PlaidLink extends React.Component<IProps, IState> {
  public state: IState = {
    linkLoaded: false
  };

  private plaid: any;

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    this.openIfNeeded(prevState);
  }

  public render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <Script
          url={PLAID_LINK_URL}
          onError={this.onScriptError}
          onLoad={this.onScriptLoaded}
        />
      </div>
    );
  }

  private onScriptError() {
    console.error("There was an issue loading the link-initialize.js script");
  }

  private onScriptLoaded = () => {
    const {
      clientName,
      env,
      publicKey,
      onExit,
      onEvent,
      onSuccess,
      products,
      selectAccount,
      token,
      webhook
    } = this.props;

    this.plaid = (window as any).Plaid.create({
      apiVersion: API_VERSION,
      clientName,
      env,
      key: publicKey,
      onExit,
      onLoad: this.handleLinkOnLoad,
      onEvent,
      onSuccess,
      product: products.join(","),
      selectAccount,
      token,
      webhook
    });
  };

  private handleLinkOnLoad = () => {
    const { onLoad } = this.props;
    if (onLoad) {
      onLoad();
    }
    this.setState({ linkLoaded: true });
  };

  private openIfNeeded(prevState: IState) {
    const { linkLoaded } = this.state;
    if (linkLoaded && !prevState.linkLoaded) {
      this.openPlaid();
    }
  }

  private openPlaid() {
    const { institution } = this.props;
    if (this.plaid) {
      this.plaid.open(institution);
    } else {
      console.error("Plaid not initilized");
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PlaidAuthenticator/components/PlaidLink.tsx